import { createFileRoute } from '@tanstack/react-router'
import { Button } from '../../components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../components/ui/card'
import { useOktaLogin } from '../../hooks/use-okta-only-auth'

export const Route = createFileRoute('/login/')({
  component: LoginPage,
})

const date = new Date()
const year = date.getFullYear()

function LoginPage() {
  const oktaLogin = useOktaLogin()

  const handleOktaLogin = () => {
    oktaLogin.mutate()
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="w-full max-w-md">
        {/* Logo/Branding Section */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-[#006837] text-white rounded-full mb-4">
            <span className="text-2xl font-bold">h</span>
          </div>
          <h1 className="text-3xl font-bold text-gray-900 mb-2">homebody</h1>
          <p className="text-gray-600">Admin Portal</p>
        </div>

        {/* Login Card */}
        <Card className="shadow-lg border-0">
          <CardHeader className="space-y-1 pb-6">
            <CardTitle className="text-2xl text-center font-semibold text-gray-900">
              Welcome back
            </CardTitle>
            <CardDescription className="text-center text-gray-600">
              Sign in to access your admin dashboard
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-6">
            {/* Okta Login Button */}
            <Button
              onClick={handleOktaLogin}
              disabled={oktaLogin.isPending}
              className="w-full h-12 bg-[#006837] hover:bg-[#004d28] text-white font-medium"
              size="lg"
            >
              {oktaLogin.isPending ? (
                <div className="flex items-center">
                  <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-3"></div>
                  Redirecting to Okta...
                </div>
              ) : (
                <div className="flex items-center">
                  <svg className="w-5 h-5 mr-3" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                  </svg>
                  <span className="text-base font-medium">Continue with Okta SSO</span>
                </div>
              )}
            </Button>

            {oktaLogin.isError && (
              <div className="text-sm text-red-600 text-center p-4 bg-red-50 rounded-lg border border-red-200">
                <strong>Authentication Error:</strong> Failed to initiate Okta login. Please try
                again.
              </div>
            )}
          </CardContent>
        </Card>

        {/* Footer */}
        <div className="text-center mt-8 text-sm text-gray-500">
          © {year} homebody. All rights reserved.
        </div>
      </div>
    </div>
  )
}
